var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightAlignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03032 2.72665H21.6364C22.2055 2.72665 22.6668 2.26535 22.6668 1.69633C22.6668 1.12732 22.2055 0.666016 21.6364 0.666016H1.03032C0.461303 0.666016 0 1.12732 0 1.69633C0 2.26535 0.461303 2.72665 1.03032 2.72665Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3643 4.78711C5.79529 4.78711 5.33398 5.24841 5.33398 5.81743C5.33398 6.38644 5.79529 6.84774 6.3643 6.84774H21.4754C22.0444 6.84774 22.5057 6.38644 22.5057 5.81743C22.5057 5.24841 22.0444 4.78711 21.4754 4.78711H6.3643Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03032 10.9688H21.6364C22.2054 10.9688 22.6667 10.5075 22.6667 9.93852C22.6667 9.36951 22.2054 8.9082 21.6364 8.9082H1.03032C0.461303 8.9082 0 9.36951 0 9.93852C0 10.5075 0.461303 10.9688 1.03032 10.9688Z",
    fill: "#232323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03032 19.211H21.6364C22.2055 19.211 22.6668 18.7497 22.6668 18.1807C22.6668 17.6117 22.2055 17.1504 21.6364 17.1504H1.03032C0.461303 17.1504 0 17.6117 0 18.1807C0 18.7497 0.461303 19.211 1.03032 19.211Z",
    fill: "#232323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3643 13.0293C5.79529 13.0293 5.33398 13.4906 5.33398 14.0596C5.33398 14.6286 5.79529 15.0899 6.3643 15.0899H21.4754C22.0444 15.0899 22.5057 14.6286 22.5057 14.0596C22.5057 13.4906 22.0444 13.0293 21.4754 13.0293H6.3643Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlignIcon);
export default __webpack_public_path__ + "static/media/right_align_icon.ee98d38285bb044c90c8bc53cf47a5c3.svg";
export { ForwardRef as ReactComponent };